<div
  data-test="hub-results-header"
  class="flex flex-row items-center gap-4 px-8"
  [class]="visible() ? 'h-20 border-b border-border' : 'justify-end py-4 border-b border-border'"
>
  @if (visible()) {
    @if (countKnown()) {
      <span data-test="hub-results-count" class="shrink-0 text-variant-md font-semibold text-gray-950">{{
        resultsLabel()
      }}</span>
    }
    <app-button2 data-test="hub-results-clear" class="shrink-0" appearance="primary-text" size="m" (click)="clear.emit()">
      {{ clearLabel() }}
    </app-button2>
    <span class="min-w-0 flex-1"></span>
  }
  <ng-content />
</div>
